exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-meida-holder{text-align:center}img.v-media{height:auto;max-height:150px}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/sharedComponents/item/Media.vue"],"names":[],"mappings":"AACA,gBAAgB,iBAAmB,CAClC,AACD,YAAY,YAAa,gBAAkB,CAC1C","file":"Media.vue","sourcesContent":["\n.v-meida-holder{text-align: center;\n}\nimg.v-media{height: auto;max-height: 150px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ecb58e4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/painel/sharedComponents/item/Media.vue
// module id = 622
// module chunks = 2